import { useMutation, useQuery } from "@tanstack/react-query";

import { getPayors, sendTransferToCompliantRX } from "@/api/transfers";

export const useTransferPatient = () => {
  const usePayors = (transferId: string, enabled?: boolean) => {
    return useQuery({
      queryKey: ["transfer", "getPayors", transferId],
      queryFn: () => getPayors(transferId),
      enabled,
    });
  };
  const useSendToCompliantRX = () => {
    return useMutation({
      mutationFn: ({
        transferId,
        payorId,
      }: {
        transferId: string;
        payorId: string;
      }) => sendTransferToCompliantRX(transferId, payorId),
    });
  };

  return { useSendToCompliantRX, usePayors };
};
